import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PagesComponent } from './components/pages/pages.component';
import { HttpModule, JsonpModule } from '@angular/http';
import { TredengineComponent } from './components/tredengine/tredengine.component';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { HomepageComponent } from './components/homepage/homepage.component';
import { LegalNotesComponent } from './components/legal-notes/legal-notes.component';
import { CookiePolicyComponent } from './components/cookie-policy/cookie-policy.component';
import { ComicstripeComponent } from './widgets/comicstripe/comicstripe.component';
import { SlideshowComponent } from './widgets/slideshow/slideshow.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { CloudHeaderComponent } from './widgets/cloud-header/cloud-header.component';

const appRoutes: Routes = [
  { path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  { path: 'home',           component: HomepageComponent },
  { path: 'legalNotes',     component: LegalNotesComponent },  
  { path: 'cookiePolicy',   component: CookiePolicyComponent },    
  { path: 'portfolio',      component: PortfolioComponent },
  { path: 'portfolio/:id',  component: PortfolioComponent },  
  { path: 'engine3d',       component: TredengineComponent },
  { path: 'pages',          component: PagesComponent },
  { path: 'pages/:id',      component: PagesComponent },
  { path: '**',             component: NotFoundComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    PagesComponent,
    TredengineComponent,
    PortfolioComponent,
    HomepageComponent,
    LegalNotesComponent,
    CookiePolicyComponent,
    ComicstripeComponent,
    SlideshowComponent,
    CloudHeaderComponent
  ],
  imports: [
    NgbModule.forRoot(),
    JsonpModule,
    HttpModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: true } // <-- debugging purposes only
    ),
    BrowserModule,
    FormsModule,
    MDBBootstrapModule.forRoot(),
    BrowserAnimationsModule
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/bompadre/Documents/angular2/myapp2/src/app/app.module.ts